import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { SseService } from 'src/app/services/SseService';
import { GestionService } from 'src/app/services/gestion.services';
import { ToastrService } from 'ngx-toastr';
import { BrokerService } from 'src/app/services/broker.services';
import { TemaService } from 'src/app/services/tema.services';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { OAuthService } from 'src/app/services/oauth.service';
import { BrokerAdapterFactory } from 'src/app/services/broker-adapter-factory.service';
import { BrokerTimeService, MarketSchedule } from 'src/app/services/broker-time.service';
import { SalidaOperacionBrokerService } from 'src/app/services/salida-operacion-broker.service';
import { IbkrOrdenService } from 'src/app/services/ibkr-orden.service';
import { esDiaHabil, fechaHoyIso, fechaOperacionBackend } from 'src/app/shared/utils/date-utils';
import { CotizacionPrecio } from '../cotizacion-fuente/cotizacion-fuente.component';

@Component({
  selector: 'app-opesalida-dialog',
  templateUrl: './opesalida-dialog.component.html',
  styleUrl: './opesalida-dialog.component.scss'
})
export class OpesalidaDialogComponent implements OnInit, OnDestroy {

  public compania: any;
  public opeventas: any;
  public selectedDato: operationinterface | undefined;
  public optimaWallCartera: OptimalWallet;
  private marketSchedule: MarketSchedule | null = null;
  public stkcfd: any;
  /** Modo de esta salida: true = solo registro en API, false = orden al broker (Live). Local: no toca el wallet. */
  public sincro: boolean = true;
  public isBroker: boolean = false;
  public isDark: boolean = false;
  public subtema: Subscription;
  /** La fecha elegida no tiene cotización en ninguna fuente: no se puede registrar. */
  public isHabil: boolean = false;
  /** Envío en curso: evita el doble clic en Aceptar. */
  public enviando: boolean = false;
  /** Último precio de <app-cotizacion-fuente> (base de LMT/STP). */
  public ultimoPrecio: number | null = null;
  public activateedPrecioOrden: boolean = false;
  public porcentaje: number = 1;
  public licencia: string;

  public retorno: any;
  theme: string | string[] | undefined;
  public ordersData = {
    orders: [
      {
        orderType: 'MKT',
        ticker: 'AAPL',
        side: 'SELL',
        quantity: 0,
        remainingquantity: 0,
        acctId: 'DU149954',
        cOID: 'nctminvst1714425916446-AAPL0:A',
        secType: '265598:STK',
        filledquantity: 0,
        parentId: 'nctminvst1714425916446-AAPL0:A',
        tif: 'GTC',
        outsideRTH: false,
        referrer: 'modelosdeinversion',
        useAdaptive: false,
        conid: 265598,
        price: 0
      }
    ]
  };
  public orderType: TypeInicator[] = [
    { type: 'MKT', value: 'MKT' },
    { type: 'Profit Target', value: 'LMT' },
    { type: 'Stop Loss', value: 'STP' }
  ];
  posicion: any;
  myControl = new FormControl('');
  options: any;
  filteredOptions: Observable<string[]>;

  constructor(
    public dialogRef: MatDialogRef<OpesalidaDialogComponent>,
    private _gestionsv: GestionService,
    private _cookieService: CookieService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _sseservice: SseService,
    private toastr: ToastrService,
    private _brokerServcice: BrokerService,
    public dialog: MatDialog,
    private temaservicio: TemaService,
    private cdr: ChangeDetectorRef, private oauthService: OAuthService,
    private brokerAdapterFactory: BrokerAdapterFactory,
    private brokerTimeService: BrokerTimeService,
    private salidaService: SalidaOperacionBrokerService,
    private ibkrOrdenService: IbkrOrdenService
  ) {

  }

  // Decimales según tipo de instrumento (CFD = 5, resto = 2)
  get decimales(): number {
    return this.stkcfd === 'CFD' ? 5 : 2;
  }

  /** Símbolo de la operación para la API propia, MetaAPI y la orden IBKR. */
  get symbol(): string {
    return (this.compania?.nombreCompania ?? '').split(' CFD')[0];
  }

  ngOnInit(): void {
    this.compania = this.normalizarOperacion(JSON.parse(JSON.stringify(this.data.compania)));
    this.optimaWallCartera = this.data.optimaWallet;
    this.stkcfd = this.compania.secType;
    this.sincro = this.optimaWallCartera?.sincro ?? true;
    this.myControl.setValue(this.compania.nombreCompania, { emitEvent: false });
    this.isBroker = this.data.isBroker;
    this.licencia = this._cookieService.get('auth_token');
    this.cargarHorarioMercado();

    this.opeventas = this.flattenArray(this.data.opeventas ?? []).map((item: any) => this.normalizarOperacion({ ...item }));
    this.options = this.opeventas;
    this.retorno = (this.compania.cantidadacciones * this.compania.cotizacion);
    this.subtema = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
        this.theme = data ? 'dark-theme' : 'light-theme';
      }
    });
    this.obtenerPosiciones();

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
  }

  /** Fecha de hoy y números con 2 decimales, como espera el formulario. */
  private normalizarOperacion(op: any): any {
    const dos = (v: any) => parseFloat(parseFloat(v).toFixed(2));
    return {
      ...op,
      fechaCotizacion: fechaHoyIso(),
      costeoperacion: dos(op.costeoperacion),
      cotizacion: dos(op.cotizacion),
      precioentradareal: dos(op.precioentradareal),
    };
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter((option: any) => option.nombreCompania.toLowerCase().includes(filterValue));
  }

  selected(event: MatAutocompleteSelectedEvent){
    let iso = event.option.value;
    this.selectedDato = this.opeventas.find((compania: any) => compania.nombreCompania === iso);
    this.seleccionarDato();
  }

  ngOnDestroy(): void {
    this.subtema?.unsubscribe();
  }

  obtenerPosiciones(){
    if (this.optimaWallCartera?.tipoBroker === 'METAAPI') {
      const adapter = this.brokerAdapterFactory.getAdapter(this.optimaWallCartera);
      const accountId = this.brokerAdapterFactory.getAccountId(this.optimaWallCartera);
      adapter.getPositions(accountId).subscribe({
        next: (positions: any[]) => {
          this.posicion = positions.find((p: any) =>
            p.symbol === this.symbol || p.symbol === this.compania.isooper
          ) ?? null;
        }
      });
      return;
    }
    // IBKR: la posición se comprueba al enviar la salida (salidaService.libroIbkr)
  }

  /** Precio de <app-cotizacion-fuente>: tiempo real si la fecha es hoy, histórico si no. */
  onPrecio(precio: CotizacionPrecio): void {
    this.ultimoPrecio = precio.last;
    this.calculoRetorno(precio.last);
  }

  calculoRetorno(data: any) {
    this.compania.cotizacion = data;
    let calculo = (this.compania.cantidadacciones * this.compania.cotizacion);
    this.retorno = parseFloat(calculo.toFixed(2));
  }

  private cargarHorarioMercado(): void {
    this.marketSchedule = null;
    if (!this.isBroker) return;
    this.brokerTimeService.getMarketSchedule(this.compania?.idNectum, this.optimaWallCartera).subscribe(schedule => {
      this.marketSchedule = schedule;
      this.cdr.markForCheck();
    });
  }

  /** La salida va al broker real con el mercado cerrado: solo se avisa, no se bloquea. */
  get avisoMercadoCerrado(): boolean {
    return this.isBroker && !this.sincro
      && this.brokerTimeService.estadoMercado(this.marketSchedule).estado === 'CERRADO';
  }

  /** En Live la salida sale hoy: se fija la fecha a hoy. */
  onCambioSincro(): void {
    if (!this.sincro) this.compania.fechaCotizacion = fechaHoyIso();
  }

  flattenArray(arrayOfArrays: any[]): any[] {
    return arrayOfArrays.flatMap(innerArray => innerArray);
  }

  seleccionarDato() {
    if (!this.selectedDato) return;
    const fecha = this.compania.fechaCotizacion;
    this.compania = { ...this.selectedDato, fechaCotizacion: fecha };
    this.stkcfd = this.compania.secType;
    this.ultimoPrecio = null;
    this.retorno = (this.compania.cantidadacciones * this.compania.cotizacion);
    this.cargarHorarioMercado();
    this.obtenerPosiciones();
  }

  /** `algoVerificado`: ya se comprobó que MetaTrader tiene Algo Trading activado. */
  guardarOpeSalida(algoVerificado = false) {
    if (this.enviando) return;
    if (!this.sincro && this.isBroker) {
      if (!algoVerificado) {
        // Algo Trading desactivado en MetaTrader: aviso y no se cancela SL/TP ni se envía la salida
        this.enviando = true;
        this.brokerAdapterFactory.puedeOperar(this.optimaWallCartera?.tipoBroker).subscribe(ok => {
          this.enviando = false;
          if (ok) this.guardarOpeSalida(true);
        });
        return;
      }
      if (this.avisoMercadoCerrado) {
        this.toastr.warning('Mercado cerrado: la orden puede ser rechazada o ejecutarse en la próxima apertura.', 'Aviso', { timeOut: 8000, positionClass: 'toast-top-center' });
      }
      this.operacionBroker();
    } else {
      this.operacionApi();
    }
  }

  operacionBroker(){
    if (this.optimaWallCartera?.tipoBroker === 'METAAPI') {
      const licencia = this._cookieService.get('auth_token');
      this.enviando = true;
      // Cierre por positionId: el broker elimina el SL/TP con la posición y se marcan cancelados en BD
      this.salidaService.cerrarPosicionMetaApi(this.compania, this.optimaWallCartera, licencia).subscribe({
        next: (res: any) => {
          const orderRecord = [{
            ticker: this.symbol,
            side: this.compania.bajista ? 'BUY' : 'SELL',
            quantity: this.compania.cantidadacciones,
            acctId: this.optimaWallCartera.nombre,
            orderType: 'MKT',
            orderId: res.positionId,
            status: 'Submitted',
            secType: this.compania.conid + ':' + this.stkcfd,
            cOID: 'nctminvst' + new Date().getTime() + this.compania.idNectum + '-' + this.compania.isooper + ':' + (this.compania.bajista ? 'B' : 'A'),
            origen: 'SALIDA_MANUAL',
          }];
          this._sseservice.apiPostNew('broker/orderNuevo', orderRecord, licencia).subscribe({
            next: (data: any) => {
              if (data.status) {
                this._brokerServcice.updatecargarListas(true);
              }
            }
          });
          this.enviando = false;
          this.dialogRef.close(true);
        },
        error: (err: any) => {
          this.enviando = false;
          this.toastr.error('MetaAPI error: ' + (err?.error?.message ?? err?.message ?? 'unknown'), 'Error', { timeOut: 30000, positionClass: 'toast-top-center' });
        }
      });
      return;
    }

    // IBKR compensa por conid: con alcista y bajista del mismo valor el neto puede ser 0 y la salida
    // sigue siendo válida. Se exige que el neto del broker cubra lo abierto en BD.
    const licencia = this._cookieService.get('auth_token');
    this.enviando = true;
    this.salidaService.libroIbkr(this.compania, this.optimaWallCartera, licencia).subscribe({
      next: libro => {
        if (!this.salidaService.posicionCubre(libro)) {
          this.enviando = false;
          this.toastr.error('No se puede salir: ' + this.salidaService.mensajeNoCuadra(this.compania, libro), 'Error', { timeOut: 30000, positionClass: 'toast-top-center' });
          return;
        }
        this.enviarSalidaIbkr(licencia);
      },
      error: (err: any) => {
        this.enviando = false;
        this.toastr.error(err?.message ?? 'No se pudo comprobar la posición en IBKR', 'Error', { timeOut: 30000, positionClass: 'toast-top-center' });
      }
    });
  }

  private enviarSalidaIbkr(licencia: string) {
    const orden = this.ordersData.orders[0];
    const bajistaStr = this.compania.bajista ? 'B' : 'A';
    orden.side = this.compania.bajista ? 'BUY' : 'SELL';
    orden.ticker = this.symbol;
    orden.quantity = this.compania.cantidadacciones;
    orden.acctId = this.optimaWallCartera.nombre;
    orden.cOID = 'nctminvst' + new Date().getTime() + this.compania.idNectum + '-' + this.compania.isooper + ':' + bajistaStr;
    orden.secType = this.compania.conid + ':' + this.stkcfd;
    orden.parentId = orden.cOID;
    orden.conid = this.compania.conid;

    // Cancelar antes el SL/TP (OCO) vivo: si queda, abriría una posición inversa tras la salida
    this.salidaService.cancelarOco(this.compania, this.optimaWallCartera, licencia).subscribe({
      next: () => {
        this.ibkrOrdenService.registrarYEnviar(this.ordersData, this.optimaWallCartera.nombre, this.theme as string, 'SALIDA_MANUAL')
          .then(ok => this.dialogRef.close(ok))
          .finally(() => this.enviando = false);
      },
      error: (err: any) => {
        this.enviando = false;
        this.toastr.error('No se envió la salida de ' + this.compania.nombreCompania + ': ' + (err?.error?.message ?? err?.message ?? err), 'Error cancelando SL/TP', { timeOut: 30000, positionClass: 'toast-top-center' });
      }
    });
  }

  operacionApi(){
    if (!esDiaHabil(this.compania.fechaCotizacion)) {
      this.toastr.error('La operacion se debe realizar en dia Habil', 'Error', { timeOut: 5000, positionClass: 'toast-top-center' });
      return;
    }
    // si tengo (0.1) 264.28 borrar los parentesis y el numero dentro de los parentesis.
    // profit y stoplossactual solo existen si el broker devolvió la posición (en Sincro no hay).
    const sinPorcentaje = (v: any) => v == null ? v : v.toString().replace(/\(.*?\)/g, '').trim();
    const operacion = {
      ...this.compania,
      bajista: String(this.compania.bajista ?? false),
      idcartera: this.optimaWallCartera.idcartera,
      secType: this.stkcfd || 'STK',// stk= stock, cfd=cfd (para el broker)
      tiporiesgo: this.optimaWallCartera.tiporiesgo,
      broker: false,
      tipoOperacion: 'SALIDA',
      preciosalidareal: this.compania.cotizacion,
      profit: sinPorcentaje(this.compania.profit),
      stoplossactual: sinPorcentaje(this.compania.stoplossactual),
      fechaOperacion: fechaOperacionBackend(this.compania.fechaCotizacion),
      // La fila trae el order_ref de la ENTRADA: OperacionImpl.crear lo toma como duplicado
      // (WHERE ... OR order_ref = :orderref) y no inserta la SALIDA aunque responda estado=true.
      order_ref: null,
    };

    this.enviando = true;
    this._sseservice.apiPostNew('registraroperacion', operacion, this.licencia).subscribe({
      next: (data: any) => {
        this.enviando = false;
        if (data.estado) {
          if(this.isBroker){
            this._brokerServcice.updateactualizarCarteraBroker(data.estado);
            this._brokerServcice.updatecargarListas(true);
          }else{
            this._gestionsv.updateactualizarCartera(data.estado);
          }
          this.dialogRef.close(data.estado);
        } else {
          this.toastr.error(data.error, 'Error', { timeOut: 5000, positionClass: 'toast-top-center' });
        }
      },
      error: (err: any) => {
        this.enviando = false;
        this.toastr.error('No se registró la salida: ' + (err?.error?.message ?? err?.message ?? 'error de red'), 'Error', { timeOut: 8000, positionClass: 'toast-top-center' });
      }
    });
  }

  activarPrecioOrden(){
    const base = Number(this.ultimoPrecio ?? this.compania.cotizacion);
    const porcentaje = parseFloat((base * (this.porcentaje / 100)).toFixed(this.decimales));
    const precioActual = parseFloat(base.toFixed(this.decimales));
    if(this.ordersData.orders[0].orderType == 'STP' || this.ordersData.orders[0].orderType == 'LMT' ){
      this.activateedPrecioOrden = true;
      // Cierre de alcista (venta): LMT por encima, STP por debajo; cierre de bajista (compra): al revés
      const porEncima = (this.ordersData.orders[0].orderType == 'LMT') !== !!this.compania.bajista;
      this.ordersData.orders[0].price = parseFloat((porEncima ? precioActual + porcentaje : precioActual - porcentaje).toFixed(this.decimales));
    }else{
      this.activateedPrecioOrden = false;
    }
  }
}


export interface TypeInicator {
  type: number | string,
  value: string | number;
}
